import React from 'react';
import { ChoiceGroup } from '@fluentui/react';

const ArcChoiceGroup = (props) => {
    const radioChangeHandler = (event, value) => {
        props.radioChangeHandler(props.config.Id, value.key);
    };

    const label = props.config.Label;

    return (
        <ChoiceGroup
            selectedKey={props.config.value}
            onKeyDown={props.onKeyDown}
            options={props.config.Options}
            onChange={radioChangeHandler}
            label={label}
        />
    );
};

export default ArcChoiceGroup;
